
<template>
    <div class="form-overlay select-mention add-alt-text" :class="position">   

        <div class="steep1">
            <p>{{ title }}</p>
            <div class="content searchMention">
                <div class="input">
                    <textarea :placeholder="placeholder" v-model="model.input" ref="inputSearch" @input="resize()"></textarea>
                </div>
            </div>

        </div>
        <div class="btn-secondary" @click="close">{{ $t('dash.button.close') }}</div>
       
    </div>
</template>


<script>
    import { EventBus } from '@/event-bus';

    export default {
        props: {
            position: {
                type: String,
                default: 'left'
            },
            id: String|Number,
            placeholder: String, 
            title: String, 
            value: String,
            
        },
       

        data() {
            return {
                model: {
                    input : this.value || ''
                }
              
            }
        },

        mounted() {
            this.$nextTick(() => {
                this.$refs.inputSearch.focus();
                this.resize()
            })
        },

        methods: {
            resize() {
                let element = this.$refs["inputSearch"];

                element.style.height = "28px";
                element.style.height = element.scrollHeight + "px";
            },

            close() {
                EventBus.$emit("eventCloseInput", this.id, this.model.input)
                this.$emit('close')
            },
        },
    }
</script>
    